import { calculateLuminance, hexToRgb } from '../../utils/color';

export const getContrastingLabelColor = (hex: string): string => {
  const { r, g, b } = hexToRgb(hex);
  const lum = calculateLuminance(r, g, b);
  return lum > 0.179
    ? 'var(--color-linear-neutral-10)'
    : 'var(--color-linear-neutral-86)';
};
